<template>
  <div style="padding-top: 45px; padding-bottom: 30px">
    <Header title="任务详情" />

    <el-form
      ref="form"
      :label-position="'top'"
      label-width="80px"
      style="width: 90%; margin: 0 auto"
    >
      <el-form-item label="任务派发单位">
        <el-select
          v-model="data.test_company"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="item in testCompanyList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工程名称">
        <el-button
          icon="el-icon-search"
          size="mini"
          plain
          type="primary"
          style="float: right; margin-top: 12px"
          @click="showSelEnginner()"
        ></el-button>
        <el-input type="textarea" autosize v-model="data.enginner_name">
        </el-input>
      </el-form-item>
      <el-form-item label="检测项目">
        <el-select
          v-model="selected_testitem"
          multiple
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="item in testitem_options"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="级别">
        <el-input v-model="data.jibie"></el-input>
      </el-form-item>
      <el-form-item label="是否签订合同">
        <div class="rightcontent">
          <el-switch v-model="data.is_qiandinghetong"> </el-switch>
        </div>
      </el-form-item>
      <el-form-item label="合同编号">
        <el-input v-model="data.hetongbianhao"></el-input>
      </el-form-item>
      <el-form-item label="内容及要求">
        <el-input
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 4 }"
          v-model="data.neirongyaoqiu"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否需要现场收费">
        <div class="rightcontent">
          <el-switch v-model="data.is_shoufei"> </el-switch>
        </div>
      </el-form-item>

      <el-form-item label="费用情况">
        <el-input v-model="data.expenses"></el-input>
      </el-form-item>

      <el-form-item label="付款方式">
        <el-select
          v-model="data.paytype"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="item in paytype_options"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人">
        <el-input v-model="data.customer"></el-input>
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input v-model="data.customer_mobile"></el-input>
      </el-form-item>

      <el-form-item label="要求出报告公司名称">
        <el-input v-model="data.report_company"></el-input>
      </el-form-item>
      <el-form-item label="需出具报告日期">
        <el-date-picker
          v-model="data.report_date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="要求进场时间">
        <el-date-picker
          v-model="data.require_in_date"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="所在地区">
        <el-cascader
          size="large"
          :options="options"
          v-model="selectedOptions"
          @change="handleChange"
          style="width: 100%"
        >
        </el-cascader>
      </el-form-item>
      <el-form-item label="详细地址">
        <el-input v-model="data.address"></el-input>
      </el-form-item>
      <el-form-item label="附件上传">
        <div class="rightcontent">
          <el-upload
            class="upload-demo"
            action="//paiche.hbgcjc.com/webapi/file.ashx"
            multiple
            :show-file-list="false"
            :on-success="handleFileSuccess"
            :limit="100"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip"></div>
          </el-upload>
        </div>
        <div class="filelist">
          <div class="fileitem" v-for="(file, index) in fileList">
            <a :href="file.url">{{ index + 1 }}、{{ file.name }}</a
            ><el-button
              type="danger"
              plain
              size="mini"
              v-on:click="delFile(file.url)"
              >删除</el-button
            >
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          style="width: 100%"
          @click="submitForm('form')"
          >提交</el-button
        >
      </el-form-item>

      <el-dialog title="选择工程" :visible.sync="dialogSelEngineer" width="90%">
        <SelEngineer
          ref="selEngineer"
          @engineerSelected="onEngineerSelected"
        ></SelEngineer>
      </el-dialog>
    </el-form>
  </div>
</template>
<script>
import Header from "@/components/header.vue";
import { regionData, CodeToText } from "element-china-area-data";
import SelEngineer from "@/views/dialog/sel_engineer.vue";
export default {
  name: "task_add",
  components: { Header, SelEngineer },
  data() {
    return {
      dialogSelEngineer: false,
      options: regionData,
      selectedOptions: [],
      testitem_options: [],
      selected_testitem: [],
      paytype_options: [],
      testCompanyList: [],
      fileList: [], //附件列表
      data: {
        enginner_name: "",
        expenses: "",
        customer: "",
        customer_mobile: "",
        address: "",
      },
      isSuccess: false,
    };
  },
  destroyed() {
    if (!this.isSuccess) {
      localStorage.setItem(
        "__cache_taskadd",
        JSON.stringify({
          data: this.data,
          selected_testitem: this.selected_testitem,
        })
      );
    }
  },
  async mounted() {
    this.testitem_options = await this.$api.request.get("/task/get_testitem");
    this.testCompanyList = await this.$api.request.get("/task/get_testcompany");
    this.paytype_options = await this.$api.request.get("/task/get_paytype");

    var id = this.$route.query.id;
    if (id) {
      this.loadData(id);
    } else {
      var fuyongid = this.$route.query.fuyongid;
      if (fuyongid) {
        this.loadFuyongData(fuyongid);
      } else {
        var cache = localStorage.getItem("__cache_taskadd");
        if (cache) {
          var cacheData = JSON.parse(cache);
          this.data = cacheData.data;
          this.selected_testitem = cacheData.selected_testitem;
        }
      }
    }
  },
  methods: {
    async loadData(id) {
      var data = await this.$api.request.get("/task/get?id=" + id);
      this.data = data;
      this.data.is_qiandinghetong = this.data.is_qiandinghetong == "true";
      this.data.is_shoufei = this.data.is_shoufei == "true";
      this.selected_testitem = this.data.test_item.split(",");
      this.fileList = data.fileList;
    },
    async loadFuyongData(id) {
      var data = await this.$api.request.get("/task/get?id=" + id);
      this.data = data;
      this.data.id = 0;
      this.data.is_qiandinghetong = this.data.is_qiandinghetong == "true";
      this.data.is_shoufei = this.data.is_shoufei == "true";
      this.selected_testitem = this.data.test_item.split(",");
      this.fileList = data.fileList;
    },
    handleFileSuccess(res, file) {
      this.fileList.push({
        name: file.name,
        url: res,
      });
    },
    delFile(url) {
      for (var i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].url == url) {
          this.fileList.splice(i, 1);
          break;
        }
      }
    },
    handleChange() {
      var loc = [];
      for (let i = 0; i < this.selectedOptions.length; i++) {
        loc.push(CodeToText[this.selectedOptions[i]]);
      }
      this.data.province = loc[0];
      this.data.city = loc[1];
      this.data.area = loc[2];
      this.data.areacode = JSON.stringify(this.selectedOptions);
    },
    async submitForm() {
      this.data.test_item = this.selected_testitem.join(",");
      var fileJson = JSON.stringify(this.fileList);
      this.data.filejson = fileJson;
      var data = await this.$api.request.post("/task/update_base", this.data);
      this.$api.success("保存成功");
      localStorage.removeItem("__cache_taskadd");
      this.isSuccess = true;
      this.$router.replace("/");
    },
    showSelEnginner() {
      this.dialogSelEngineer = true;
      this.$nextTick(() => {
        this.$refs.selEngineer.showInfo();
      });
    },
    onEngineerSelected(item) {
      this.dialogSelEngineer = false;
      this.data.enginner_name = item.name;
      this.data.customer = item.customer;
      this.data.customer_mobile = item.customer_mobile;
      this.data.province = item.province;
      this.data.city = item.city;
      this.data.area = item.area;
      this.data.address = item.address;
      this.data.areacode = item.areacode;
      this.selectedOptions = JSON.parse(item.areacode);
    },
  },
};
</script>
<style scoped>
.el-date-editor.el-input {
  width: 100% !important;
}
.filelist {
}
.fileitem {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 5px;
  line-height: initial;
}
.fileitem a {
  color: #0f7ff3;
  text-decoration: none;
  text-align: left;
}
.rightcontent {
  text-align: right !important;
}
</style>
